import { templateThemeTokens } from './templateThemeTokens.js';
import { THEME_DEFAULT_FONTS } from '@/contexts/CustomThemeConfigContext/constants.js';
import { createTheme } from '@/stitches/index.js';

export const midnight = createTheme({
  ...templateThemeTokens,
  colors: {
    defaultFont: '#FFFFFF',
    pageBackground: '#45192F',
    secondaryFont: '#CD74DD',
  },
  fonts: {
    accent: THEME_DEFAULT_FONTS.sydney.midnight.accent
      ? THEME_DEFAULT_FONTS.sydney.midnight.accent.value
      : 'unset',
    body: THEME_DEFAULT_FONTS.sydney.midnight.body.value,
    heading: THEME_DEFAULT_FONTS.sydney.midnight.headline.value,
  },
  shadows: {
    basic10: '0 0 $64 rgba(228, 232, 247, 0.15)',
  },
});
